export default "__VITE_ASSET__DgUb6uU0__"